import { CreatedInterfaces } from '../interfaces';
import { getErrorMessage } from '../utils/errorCodes';
import { usePostRequest } from './utils/usePostRequest';

const resource = 'nominate-card-post'

const useNominateCard = () => {
  const [{ data, error, loading }, nominateCard] = usePostRequest<CreatedInterfaces<typeof resource>>({
    path: 'v1/cards/unnamed/assign/decrypt'
  });

  return {
    nominateLoading: loading,
    nominateError: getErrorMessage(error?.response?.data?.errors[0]?.message),
    nominateCard,
    unnamedLot: data
  };
};

export default useNominateCard;